import React from 'react';
import { ReduxUpdater } from '../../redux/ReduxUpdater';
import { menuCollapsedState } from '../../redux/slices/statusesSlice';
import { useSelector } from 'react-redux';
import { SidebarClose } from 'lucide-react';
import ProtectedNav from './elements/ProtectedNav';
import Expenses from './icons/Expenses';
import { NavLink } from 'react-router-dom';
import Crew from './icons/Crew';
import Fleet from './icons/Fleet';
import Integrations from './icons/Integrations';
import Employees from './icons/Employees';
import { lastAuthenticatedUserState } from '../../redux/slices/tsSlice';
import { GlobalConstants } from '../../GlobalConstants';

const HeaderContent = () => {
    const authenticatedUserTS =  useSelector(lastAuthenticatedUserState);
    
    const isMenuCollapsed = useSelector(menuCollapsedState);
    const iconSize = 36;
    const iconColor = 'whitesmoke';

    const authenticatedUser = React.useMemo(() => {
        return (
            <>
                <div data-svg-wrapper data-layer="Avatar" className="Avatar relative">
                    <img
                        className="shrink-0 size-12 rounded-full"
                        src={ReduxUpdater.authenticatedUser?.profile_image_bytes}
                        alt={ReduxUpdater.authenticatedUser?.first_name + ' ' + ReduxUpdater.authenticatedUser?.last_name}
                    />
                </div>
                <div data-layer="Info" className="Info w-40 inline-flex flex-col justify-start items-start gap-0.5">
                    <div className="self-stretch justify-center text-text-lighter text-base font-semibold font-['Inter'] leading-snug">{ReduxUpdater.authenticatedUser?.first_name} {ReduxUpdater.authenticatedUser?.last_name}</div>
                    <div className="self-stretch justify-center text-text-light text-base font-normal font-['Inter'] leading-snug">{ReduxUpdater.authenticatedUser?.position}</div>
                </div>
            </>
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticatedUserTS]);

    if (isMenuCollapsed) {
        return (
            <div
            data-layer="headerElement"
            className="self-stretch p-2 inline-flex justify-start items-center overflow-hidden bg-bg-sidebar gap-2.5"
            style={{
                backgroundImage: 'url(assets/header.jpg)'
            }}
        >
            <button
                onClick={() => {
                    ReduxUpdater.menuCollapsed = !isMenuCollapsed;
                }}
            >
                <SidebarClose height={iconSize} width={iconSize} color={iconColor} />
            </button>
            <div className="flex items-center text-text-hero text-5xl font-extrabold font-['Inter']">Maris</div>

            {([GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') || true) && <NavLink to="/fleet" className="justify-center text-gray-800 text-sm font-normal font-['Inter'] leading-tight"><Fleet height={iconSize} width={iconSize} fill={iconColor} /></NavLink>}
            {[GlobalConstants.UserRole.ROOT].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') && <NavLink to="/employees" className="justify-center text-gray-800 text-sm font-normal font-['Inter'] leading-tight"><Employees height={iconSize} width={iconSize} fill={iconColor} /></NavLink>}
            {[GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') && <ProtectedNav to="/crew" labelOrElement={<Crew height={iconSize} width={iconSize} stroke={iconColor} />} />}
            {[GlobalConstants.UserRole.ROOT].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') && <ProtectedNav to="/integrations" labelOrElement={<Integrations height={iconSize} width={iconSize} fill={iconColor} />} />}
            <ProtectedNav to="/expenses" labelOrElement={<Expenses height={iconSize} width={iconSize} fill={iconColor} />} />

            <div className="w-[-webkit-fill-available]">&nbsp;</div>

            <button
                onClick={() => ReduxUpdater.currentDialog = 'userSettings'}
            >
                <img
                    className="shrink-0 size-12 rounded-full"
                    src={ReduxUpdater.authenticatedUser?.profile_image_bytes}
                    alt={ReduxUpdater.authenticatedUser?.first_name + ' ' + ReduxUpdater.authenticatedUser?.last_name}
                />
            </button>
        </div>
        );
    }

    return (
        <div
            data-layer="headerElement"
            className="self-stretch px-8 inline-flex justify-between items-center overflow-hidden"
            style={{
                backgroundImage: 'url(assets/header.jpg)'
            }}
        >
            <div className="min-h-20 flex items-center text-text-hero text-5xl font-extrabold font-['Inter']">Maris</div>
            <button
                data-layer="Avatar Block"
                className="AvatarBlock w-80 flex justify-end items-center gap-3"
                onClick={() => ReduxUpdater.currentDialog = 'userSettings'}
            >
                {authenticatedUser}
            </button>
        </div>
    );
};

export default HeaderContent;